<template>
  <div id="canvas" v-if="userData.loggedIn" class="gift-choice-page" :class="collectionData.isBundle ? 'bundle' : ''">
    <div id="mContainer" class="main-container no-scrollbar">
      <!--Corporate Header -->
      <div class="header-container corporate p-relative w-100" v-if="collectionData.videoHeaders[0] || collectionData.collectionImage">
        <video v-if="collectionData.videoHeaders[0]" class="custom-header desktop" :class="(isOneRedeem || isSingleTab1Gift) ? 'no-tabs' : ''" autoplay="autoplay" playsinline="" muted="" loop="loop" alt="gif" :src="collectionData.videoHeaders[0]"></video>
        <img v-else-if="collectionData.collectionImage" :src="collectionData.collectionImage.src" class="custom-header desktop" :class="(isOneRedeem || isSingleTab1Gift) ? 'no-tabs' : ''" width="1920px"/>
        <video v-if="collectionData.videoHeaders[1]" class="custom-header mobile" autoplay="autoplay" :class="(isOneRedeem || isSingleTab1Gift) ? 'no-tabs' : ''" playsinline="" muted="" loop="loop" alt="gif" :src="collectionData.videoHeaders[1]"></video>
        <img v-else-if="collectionData.collectionImage" :src="collectionData.collectionImage.alt" class="custom-header mobile" :class="(isOneRedeem || isSingleTab1Gift) ? 'no-tabs' : ''" width="1920px"/>
        <div v-if="collectionData.keepHeadersTitles" class="floating-text">
          <p class="main-title">{{ headerTitle }}</p>
          <p v-if="collectionData.keepHeaderSubtitle" class="main-subtitle">{{ headerSubtitle }}</p>
        </div>
      </div>
      <!--Default Header -->
      <div class="header-container p-relative w-100" v-else>
        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/goc_header_new_1.png?v=1750865983" class="w-100 desktop" width="1920">
        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/goc_header_new_mobile.png?v=1750865982" class="w-100 mobile" width="1920">
        <div class="floating-text">
          <p class="main-title">Pick Your Gift!</p>
          <p class="main-subtitle"> You can pick one or many gifts to hit the <br class="mobile"/> value your sender has selected. </p>
        </div>
      </div>
      <!--End Default Header -->
      <div v-if="!isOneRedeem && !isSingleTab1Gift" id="tabs" class="tabs" :class="[uiState.isSticking ? 'sticky' : '',uiState.showTicker ? 'hasTicker' : '']">
        <div class="tab" :class="[(uiState.selectedTab == tab.value || (!uiState.selectedTab && i == 0)) ? 'selected' : '',(collectionData.isBundle && tab.value > 0 && tabs[tab.value - 1].currentQty > 0) ? 'disabled' : '',(!collectionData.isBundle && tab.currentQty == 0) ? 'disabled' : '']" v-for="(tab,i) in tabs">
          <div @click="selectTab(tab.value)" class="happybox-button white">
            <span v-if="collectionData.isBundle">Step {{ i+1 }}:&nbsp;</span>
            <span v-if="tab.maxQty == 1">Pick {{ tab.currentQty }}{{ tab.leftOver > 0 ? '+ Gift(s)' : ' Gift' }}</span>
            <span v-else-if="tab.maxQty > 1">Pick up to {{ tab.currentQty }} Gifts</span>
          </div>
        </div>
      </div>
      <div class="ticker" v-if="collectionData.tickerText && collectionData.tickerText != ''" :style="collectionData.tickerColor ? 'background-color:' + collectionData.tickerColor : ''">
        <p>{{ collectionData.tickerText }}</p>
      </div>
      <div class="products-listing">
        <p class="capacity-overlay" v-if="maxProductsToAdd == 0">100% full! Proceed to the next step <br class="mobile"/> or remove items to keep shopping.</p>
        <p class="bundle-instructions" v-html="bundleInstructions" v-if="bundleInstructions && maxProductsToAdd != 0"></p>
        <p class="step-warning" v-if="stepWarningMessage">{{ stepWarningMessage }}</p>
        <p class="purple-copy" v-if="isHBHoliday && isOneRedeem">Redeem your holiday gift below!</p>
        <p class="tier-subcopy" v-if="!isHBHoliday && !collectionData.isBundle" v-html="tabCopy"></p>
        <div class="products-inner-container-wrapper">
          <div v-if="collectionData.product_videos.length > 0 && collectionData.product_videos[currentTabIndex]" class="product-video-container">
            <video id="product-video" autoplay loop muted  alt="product video" :src="collectionData.product_videos[currentTabIndex]" controls controlsList="nodownload noremoteplayback noplaybackrate" disablepictureinpicture></video>
          </div>
          <div class="products-inner-container" :class="[maxProductsToAdd == 0 ? 'disabled' : '', (collectionData.product_videos.length > 0 && collectionData.product_videos[currentTabIndex]) ? 'has-videos' : '']">
          <div v-for="product in filteredProducts" :key="product.id" class="product-container" :class="[cartData.cartProducts.find(x => x.id == product.id) ? 'selected' : '',isOneRedeem ? 'big':'']">
            <img @click="removeProduct(product)" class="circle remove"  src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_blue.svg?v=1784232486" alt="x">
            <div @click="selectProduct(product)" class="product-image-container" >
              <span v-if="mainBadge(product) != null" class="main-badge">{{ mainBadge(product) }}</span>
              <img class="info" src="https://cdn.shopify.com/s/files/1/1363/8433/files/info.svg?v=1734017876"/>
              <div class="loading">
                <img class="lazyload main-image" width="150" height="150" :src="product | getProductImage"/>
              </div>
              <img v-if="product.images.length > 1 && !isNoHover(product)" :src="product.images[1].src" class="hover-image" />
            </div>
            <p class="product-title">{{ product.title }}</p>
            <button v-if="isOneRedeem" @click="selectProduct(product)" class="happybox-button green border">Redeem</button>
          </div>
        </div>
        </div>
      </div>
    </div>
    <SideCart 
      :capacity="percentageFilledCapacity" 
      :selectedProducts="cartData.cartProducts" 
      :maxProductsToAdd="maxProductsToAdd"
      :isLoading="uiState.isLoading"
      :isBundle="collectionData.isBundle"
      :tabs="tabs"
      :redeem_without_full_capacity="collectionData.redeem_without_full_capacity"
      :minimumProductsToAdd="minimumProductsToAdd"
      :canCheckout="canProceedToCheckout"
      @removeproduct="removeProduct($event)"
      @checkout="goCheckout"
      @openmodal="openModal($event)"
    />
    <ProductModal 
      v-if="uiState.selectedProduct" 
      :collectionValue="collectionValue"
      :availableCapacity="availableCapacity"
      :product="uiState.selectedProduct" 
      :cartProducts="cartData.cartProducts"
      :isLoading="uiState.isLoading"
      :isBundle="collectionData.isBundle"
      :tabs="tabs"
      :isOneRedeem="isOneRedeem"
      :collectionHandle="collectionData.collectionHandle"
      @closemodal="closeModal"
      @changevariant="changeVariant"
      @selectproduct="addProduct($event)" 
      @cleanadd="cleanAdd($event)"
      @checkout="goCheckout"
      @nextstep="nextStep()"
    />
  </div>
  <div v-else-if="sso && !loginData.loading" class="login-page" :style="loginPageStyle">
        <img :src="loginData.loginLogo || 'https://cdn.shopify.com/s/files/1/1363/8433/files/LOGO_sparkle-01.png?v=1726671236'" alt="Happy Box Logo" class="logo" />
        <div  class="login-container">
          <div class="login-header">
              <h2 v-html="loginData.loginTitle || 'Login to Happy Box'" :style="loginData.loginTitleColor ? 'color:' + loginData.loginTitleColor : ''"></h2>
              <p class="body-base" v-if="loginData.loginSubtitle" :style="loginData.loginSubtitleColor ? 'color:' + loginData.loginSubtitleColor : ''">{{ loginData.loginSubtitle}}</p>
          </div>
          <template v-if="!loadingSSO">
              <div class="logged-container" v-if="userData.isLoggedIn && userData.loggedUser">
                You are logged in as {{ userData.loggedUser.email }} <br/> which does not have access to this collection.
                <div class="signup-prompt">
                  <p><a href="#" @click="logout">Try Again</a></p>
                </div>
              </div>
              <div class="alternative-login">
                <button type="button" @click="ssologin('google')" class="google-sign-in-button" >
                    Sign in with Google
                </button>
                <button v-if="loginData.hideMSButton == false" type="button" @click="ssologin('microsoft')" class="google-sign-in-button microsoft" >
                    Sign in with Microsoft
                </button>
              </div>
          </template>
          <div class="login-spinner" v-else>
              <div class="global-spinner"></div>
          </div>
        </div>
        <p v-if="loginData.loginLogo" :style="loginData.loginPoweredByColor ? 'color:' + loginData.loginPoweredByColor : ''" class="flex flex-align-center flex-justify-center gap-05vw font-bold body-base m-t-1rem">Powered by <img width="40" class="h-auto" src="https://cdn.shopify.com/s/files/1/1363/8433/files/LOGO_sparkle-01.png?v=1726671236" alt="Happy Box Logo" /></p>
    </div>
  <div v-else class="spinner-container" :class="uiState.reclaimed ? 'top' : ''">
    <p v-if="uiState.invalidToken">Invalid Access</p>
    <div class="reclaimed-container" v-else-if="uiState.reclaimed">
      <p class="title">
        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"/>
        <span>Great Choice</span>
        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"/>
      </p>
      <p class="subtitle">You'll receive updates and tracking info via email!</p>
    </div>
    <div v-else class="loading-container">
      <p>
        If you are having trouble loading this page, please turn off your VPN or company wifi. <br class="desktop"/> Due to IT security restrictions, you may need to open the link on a personal device or forward the email to a personal email address to redeem your gift.<br class="desktop"/>
        If you are still having issues, please reach out to <a href="mailto:orders@happyboxstore.com">orders@happyboxstore.com</a> for immediate assistance.
      </p>
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
import confetti from "canvas-confetti";
import axios from "axios";
import ProductModal from "./components/ProductModal.vue";
import SideCart from "./components/SideCart.vue";
import Vue from "vue";
import Swal from 'sweetalert2/dist/sweetalert2.js'

// Constants
const API_ENDPOINTS = {
  GIFT_LOGIN: "https://portal.happyboxstore.com:5054/giving/giftLogin",
  SPECIAL_CHECKOUT: "https://portal.happyboxstore.com:5054/giving/specialCheckout",
  SSO_ME: "https://api.happyboxstore.com/api/sso/corporate/goc/me",
  SSO_LOGIN: "https://api.happyboxstore.com/api/sso/login",
  SSO_LOGOUT: "https://api.happyboxstore.com/api/sso/logout"
};

const CSS_CLASSES = {
  STICKY: 'sticky',
  SELECTED: 'selected',
  DISABLED: 'disabled',
  NO_TABS: 'no-tabs',
  BIG: 'big'
};

const ANIMATION_DURATION = 5000;

export default {
    data(){
        return {
          isMobile: window.innerWidth <= 768,
            // Collection and product data
            collectionData: {
              products: [],
              bundles: [],
              isBundle: false,
              collectionHandle: null,
              collectionCapacity: 0,
              collectionImage: null,
              collectionValue: 0,
              header_title: "",
              header_subtitle: "",
              productSent: "",
              corporate: null,
              extraProperties: [],
              videoHeaders: [],
              tickerText: "",
              tickerColor: null,
              redeem_without_full_capacity: false,
              minimum_redemption_value: 0, //in capacity
            },
            loginData: {
              loginBackgroundColor: null,
              loginBackgroundImage: null,
              loginMobileBackgroundImage: null,
              loginLogo: null,
              loginTitle: null,
              loginSubtitle: null,
              loginButton: null,
              loginButtonText: null,
              loginButtonLink: null,
              loading: false,
              hideMSButton: false,
            },
            // UI state
            uiState: {
              selectedProduct: null,
              selectedTab: null,
              stepWarningTab: null,
              isSticking: false,
              showTicker: false,
              isLoading: false,
              confirmed: false,
              reclaimed: false,
              invalidToken: false
            },
            
            // User and authentication
            userData: {
              loggedIn: false,
              giftToken: null,
              loggedUser: null,
              isLoggedIn: false
            },
            
            // Cart and selection
            cartData: {
              cartProducts: [],
              steps: ["PICK YOUR GIFT","ADD YOUR ADDRESS"],
              fixed_address: null,
              individualChoice: false
            },
            
            // SSO specific
            sso: false,
            loadingSSO: true,
            
            // Mouse/touch tracking
            pointerPosition: { x: 0, y: 0 }
        }
    },
    components: {
      SideCart,
      ProductModal
    },
    computed:{
      // Simplified tabs computation
      tabs(){
        if(this.collectionData.isBundle){
          return this.computeBundleTabs();
        }
        
        if(this.collectionData.products?.length > 0 && this.collectionValue){
          return this.computeProductTabs();
        }
        
        return [];
      },
      
      headerTitle(){
        if(this.collectionData.header_title && this.collectionData.header_title !== ""){
          return this.collectionData.header_title;
        }
        return `Time to ${this.isOneRedeem ? 'Claim' : 'Pick'} Your Gift!`;
      },
      headerSubtitle(){
        if(this.collectionData.goc_header_subtitle && this.collectionData.goc_header_subtitle !== ""){
          return this.collectionData.goc_header_subtitle;
        }
        return `You can pick one or many gifts to hit the value your sender has selected.`;
      },
      
      collectionValue(){
        return this.collectionData.collectionCapacity;
      },

      currentTabIndex(){
        return this.tabs.findIndex(x => x.value === this.getCurrentTabValue());
      },
      
      filteredProducts(){
        if(!this.tabs) return [];
        
        const currentTab = this.getCurrentTabValue();
        let products = [];
        
        if(this.collectionData.isBundle){
          products = this.collectionData.bundles[currentTab].products;
        } else {
          products = this.filterProductsByTab(currentTab);
        }
        
        return products;
      },
      
      filledCapacity(){
        if(!this.cartData.cartProducts?.length || !this.collectionValue) return 0;
        
        const values = this.cartData.cartProducts.map((x) => {
          const value = this.calculateProductValue(x);
          return value * x.qty;
        });
        
        return values.reduce((sum, val) => sum + val, 0);
      },
      
      percentageFilledCapacity(){
        if(this.collectionData.isBundle){
          const totalUsed = this.bundleAvailableCapacity.reduce((sum, val) => sum + val, 0);
          const totalMax = this.tabs.reduce((sum, tab) => sum + tab.maxQty, 0);
          return Math.round((totalUsed * 100) / totalMax);
        }
        
        return Math.round((this.filledCapacity * 100) / this.collectionValue);
      },
      
      bundleAvailableCapacity(){
        if(!this.collectionData.isBundle) return [];
        
        return this.collectionData.bundles.map((x, i) => {
          const products = this.cartData.cartProducts.filter(x => x.tab === i);
          return products.reduce((sum, product) => sum + product.qty, 0);
        });
      },
      
      availableCapacity(){
        return this.collectionValue - this.filledCapacity;
      },

      canProceedToCheckout(){
        if(this.collectionData.redeem_without_full_capacity === true){
          const minimum = Number(this.collectionData.minimum_redemption_value) || 0;
          if(minimum > 0){
            return this.filledCapacity >= minimum;
          }
          return true;
        }

        return this.maxProductsToAdd === 0;
      },
      minimumProductsToAdd(){
        if(this.collectionData.redeem_without_full_capacity === true){
          const minimum = Number(this.collectionData.minimum_redemption_value) || 0;
          if(minimum > 0){
            const tabValues = this.tabs.map(x => x.value);
            return Math.ceil(minimum / Math.min(...tabValues));
          }
          return 0;
        }
        return 0;
      },
      
      maxProductsToAdd(){
        if(!this.tabs?.length) return 0;
        
        if(this.collectionData.isBundle){
          return this.tabs.reduce((sum, x) => sum + x.currentQty, 0);
        }
        
        const tabValues = this.tabs.map(x => x.value);
        return Math.floor(this.availableCapacity / Math.min(...tabValues));
      },
      
      dataToAdd(){
        if(!this.cartData.cartProducts?.length) return [];
        
        const baseProperties = this.buildBaseProperties();
        
        return this.cartData.cartProducts.map((product) => {
          const data = {
            id: product.variants[0].id,
            quantity: product.qty,
            properties: Object.assign(product.properties || {}, baseProperties)
          };
          
          this.addProductSpecificProperties(data, product);
          this.addExtraProperties(data, product);
          
          return data;
        });
      },
      
      bundleInstructions(){
        if (!this.collectionData.isBundle) return null;
        
        return `<p>It's time to pick your gift! You'll be prompted to pick out ${this.tabs[this.currentTabIndex].maxQty} total gifts.</p>`;
      },

      stepWarningMessage(){
        if(!this.collectionData.isBundle || this.uiState.stepWarningTab == null) return null;

        const tab = this.tabs[this.uiState.stepWarningTab];
        if(!tab || tab.currentQty === 0) return null;

        if(tab.currentQty == tab.maxQty){
          return `Please select ${tab.maxQty} gifts to continue`;
        }
        else
          return `Please select ${tab.maxQty - tab.currentQty} more gifts to continue`;
      },
      
      isOneRedeem(){
        return (this.tabs.length === 1 && this.filteredProducts.length === 1);
      },
      
      isSingleTab1Gift(){
        return (this.tabs.length === 1 && this.tabs[0].maxQty === 1);
      },
      
      isHBHoliday(){
        return this.collectionData.collectionHandle?.includes("client-eoy-2024-gift-");
      },
      
      tabCopy(){
        if(this.collectionData.header_subtitle && this.collectionData.header_subtitle !== ""){
          return this.collectionData.header_subtitle;
        }
        
        const currentTabValue = this.getCurrentTabValue();
        const currentTab = this.tabs.find(x => x.value === currentTabValue);
        
        if(!currentTab) return "";
        
        if(currentTab.maxQty === 1){
          if(currentTab.leftOver === 0){
            return "You're able to select <strong>one</strong> gift from the below.";
          }
          return "You're able to select <strong>one</strong> gift from the below, and one from another available collection.";
        }
        
        if(currentTab.maxQty > 1){
          return "Mix and match gifts from the below & other available collections to your liking!";
        }
        
        return "";
      },
      loginPageStyle() {
        const style = {};
        if (this.loginData.loginBackgroundColor) {
          style.backgroundColor = this.loginData.loginBackgroundColor;
        }
        const backgroundImage = this.isMobile
        ? this.loginData.loginMobileBackgroundImage
        : this.loginData.loginBackgroundImage

        if (backgroundImage) {
          style.backgroundImage = `url(${backgroundImage})`
          style.backgroundSize = 'cover'
          style.backgroundPosition = 'center'
        }
        return style;
      },
    },
    methods:{
      getCurrentTabValue(){
        return this.uiState.selectedTab ?? this.tabs[0]?.value ?? 0;
      },

      // Tab computation methods
      computeBundleTabs(){
        const values = this.collectionData.bundles.map((x, i) => ({
          maxQty: x.qty,
          value: i,
          currentQty: x.qty - this.bundleAvailableCapacity[i]
        }));
        return values.sort((a, b) => a.value - b.value);
      },
      
      computeProductTabs(){
        const values = this.collectionData.products.map((x) => {
          let value = this.extractCapacityFromTags(x.tags);
          
          const customValue = this.extractCustomCapacity(x.tags);
          if(customValue) value = customValue;
          
          return value;
        });
        
        const uniqueValues = [...new Set(values.filter(x => x > 0))];
        const tabData = uniqueValues.map(x => ({
          maxQty: Math.floor(this.collectionValue / x),
          value: x,
          currentQty: Math.floor(this.availableCapacity / x),
          leftOver: this.collectionValue % x
        }));
        
        return tabData.sort((a, b) => b.value - a.value);
      },
      
      extractCapacityFromTags(tags){
        const tagsArray = tags.split(", ");
        const valueTag = tagsArray.find(y => y.toLowerCase().includes("goc_capacity_"));
        if(valueTag){
          return parseInt(valueTag.split("_")[2]);
        }
        return 0;
      },
      
      extractCustomCapacity(tags){
        const tagsArray = tags.split(", ");
        const customValue = tagsArray.find(y => y.toLowerCase().includes(`custom_capacity_${this.collectionData.collectionHandle}`));
        if(customValue){
          return parseInt(customValue.split("_")[3]);
        }
        return null;
      },
      
      filterProductsByTab(currentTab){
        return this.collectionData.products.filter((x) => {
          const tags = x.tags.split(", ");
          const customValue = tags.find(y => y.toLowerCase().includes(`custom_capacity_${this.collectionData.collectionHandle}`));
          
          if(customValue){
            return tags.some(tag => tag.toLowerCase() === `custom_capacity_${this.collectionData.collectionHandle}_${currentTab}`);
          }
          
          return tags.some(tag => tag === `GOC_Capacity_${currentTab}`);
        });
      },
      
      calculateProductValue(product){
        const tags = product.tags.split(", ");
        let value = 0;
        
        const valueTag = tags.find(y => y.toLowerCase().includes("goc_capacity_"));
        if(valueTag){
          value = parseInt(valueTag.split("_")[2]);
        }
        
        const customValue = tags.find(y => y.toLowerCase().includes(`custom_capacity_${this.collectionData.collectionHandle}`));
        if(customValue){
          value = parseInt(customValue.split("_")[3]);
        }
        
        return value;
      },
      
      buildBaseProperties(){
        const baseProperties = {};
        
        if(this.collectionData.corporate){
          baseProperties.Corporate = true;
          baseProperties.CorporateName = this.collectionData.corporate;
          baseProperties._corpGift = this.userData.giftToken;
        } else {
          baseProperties._gift = this.userData.giftToken;
        }
        if(this.sso){
          baseProperties._sso = true;
        }
        
        baseProperties._redeem = true;
        baseProperties._collectionRedeemed = this.collectionData.productSent;
        
        return baseProperties;
      },
      
      addProductSpecificProperties(data, product){
        const tags = product.tags.split(", ");
        if(this.collectionData.corporate){
          data.properties._value = this.findItemPrice(product);
        }
        
        if(tags.find(x => x.includes("Dropship_"))){
          const dropshipTag = tags.find(x => x.includes("Dropship_"));
          const dropshipIdTag = tags.find(x => x.includes("DropshipId_"));
          data.properties._Dropship = dropshipTag.split("_")[1];
          data.properties._DropshipId = dropshipIdTag.split("_")[1];
        }
      },
      
      addExtraProperties(data, product){
        if(this.collectionData.extraProperties?.length > 0){
          const productExtras = this.collectionData.extraProperties.filter(x => x.id === product.id);
          for(const property of productExtras){
            data.properties[property.name] = property.value;
          }
        }
      },
      
      // Product selection methods
      selectProduct(product){
        this.uiState.selectedProduct = product;
        if(this.isOneRedeem && product.variants.length === 1){
          const productToSend = JSON.parse(JSON.stringify(product));
          productToSend.qty = 1;
          this.addProduct(productToSend);
        }
      },
      
      findItemPrice(item){
        const tags = item.tags.split(", ");
        // Priority 1: Corporate price tag
        const corporateTag = tags.find(tag => tag.startsWith(`${this.collectionData.corporate}_Price_`));
        if (corporateTag) {
          return parseFloat(corporateTag.split('_').pop());
        }
        
        // Priority 2: Price history
        const price = this.extractPriceFromHistory(tags);
        if (price !== null) {
          return price;
        }

        if(tags.find(x => x.includes("Value_"))){
          const valueTag = tags.find(x => x.includes("Value_"));
          return parseFloat(valueTag.split("_")[1]);
        }
        
        // Priority 3: Fallback price tags
        return this.extractFallbackPrice(tags);
      },
      
      extractPriceFromHistory(tags){
        const historyTags = tags
          .filter(tag => tag.startsWith("PriceHistory_"))
          .map(tag => {
            const [_, indexStr, ...entries] = tag.split('_');
            const index = parseInt(indexStr);
            return { index, entries };
          })
          .sort((a, b) => a.index - b.index);
        
        if(historyTags.length === 0) return null;
        
        const allEntries = [];
        for(const tag of historyTags){
          for(const entry of tag.entries){
            const [label, priceStr] = entry.split(':');
            allEntries.push({
              date: label === 'INIT' ? '00000000' : label,
              price: parseFloat(priceStr),
            });
          }
        }
        
        if(allEntries.length === 0) return null;
        
        const sorted = allEntries.sort((a, b) => a.date.localeCompare(b.date));
        const today = new Date();
        const rangeStart = today.toISOString().slice(0, 10).replace(/-/g, '');
        
        const matching = sorted.filter(entry => entry.date <= rangeStart);
        return matching.length > 0 ? matching[matching.length - 1].price : null;
      },
      
      extractFallbackPrice(tags){
        const fallbackTag = tags.find(tag => tag.startsWith('Price_'));
        const fallbackTag2 = tags.find(tag => tag.startsWith('GOC_Capacity_'));
        
        if(fallbackTag){
          return parseFloat(fallbackTag.split('_').pop());
        }
        
        if(fallbackTag2){
          return parseFloat(fallbackTag2.split('_').pop());
        }
        
        return null;
      },
      
      // Modal and UI methods
      closeModal(){
        this.uiState.selectedProduct = null;
      },
      
      addProduct(event){
        const variantId = event.variants[0].id;
        const existingIndex = this.cartData.cartProducts.findIndex(x => 
          x.variants.find(y => y.id === variantId)
        );
        
        if(existingIndex < 0){
          this.triggerConfetti();
          this.cartData.cartProducts.push(event);
        } else {
          Vue.set(this.cartData.cartProducts[existingIndex], "qty", event.qty);
        }
      },
      
      triggerConfetti(){
        confetti({
          origin: {
            x: this.pointerPosition.x,
            y: this.pointerPosition.y
          },
          zIndex: 9000
        });
      },
      
      cleanAdd(event){
        if(this.collectionData.isBundle){
          this.cartData.cartProducts = this.cartData.cartProducts.filter(x => x.tab !== event.tab);
        } else {
          this.cartData.cartProducts = [];
        }
        this.addProduct(event);
      },
      
      removeProduct(product){
        const removedTab = product.tab;
        const currentTab = this.getCurrentTabValue();
        const variantId = product.variants[0].id;
        let index = this.cartData.cartProducts.findIndex(x => 
          x.variants.find(y => y.id === variantId)
        );
        
        if(index > -1){
          this.cartData.cartProducts.splice(index, 1);
        } else {
          const productId = product.id;
          index = this.cartData.cartProducts.findIndex(x => x.id === productId);
          if(index > -1){
            this.cartData.cartProducts.splice(index, 1);
          }
        }

        if(this.collectionData.isBundle && removedTab != null && removedTab < currentTab){
          this.uiState.selectedTab = removedTab;
          this.uiState.stepWarningTab = removedTab;
          this.uiState.selectedProduct = null;
          document.getElementById('mContainer')?.scrollTo({ top: 0, behavior: 'auto' });
        }
      },
      
      mainBadge(product) { 
        const splitTags = product.tags.split(", ");

        // Check for Tag_ tags
        const tagResult = splitTags
            .filter(tag => tag.includes("Tag_"))
            .map(tag => tag.replace(/Tag_/g, "")); // Replace all Tag_ in one go

        if (tagResult.length > 0) {
            return tagResult[0];
        }

        // Check for Filter_Ethos tags
        const ethosResult = splitTags
            .filter(tag => tag.includes("Filter_Ethos"))
            .map(tag => tag.replace("Filter_", "").split("_")[1]);

        if (ethosResult.length > 0) {
            return ethosResult[0];
        }

        return null;
    },
      
      changeVariant(event){
        if(this.collectionData.extraProperties.length > 0){
          const index = this.collectionData.extraProperties.findIndex(x => x.name === event.name);
          if(index > -1){
            this.collectionData.extraProperties[index].value = event.value;
            return;
          }
        }
        this.collectionData.extraProperties.push(event);
      },
      
      openModal(product){
        const selected = this.collectionData.products.find(x => x.id === product.id);
        if(selected){
          this.uiState.selectedProduct = selected;
        }
      },
      
      // Authentication methods
      async login(){
        this.userData.giftToken = localStorage.getItem("giftToken");
        if(!this.userData.giftToken){
          this.uiState.invalidToken = true;
          return;
        }
        
        try {
          const response = await axios.post(API_ENDPOINTS.GIFT_LOGIN, {
            token: this.userData.giftToken
          });
          
          if(response.data){
            await this.finishLogin(response.data);
          }
        } catch(error) {
          console.error('Login error:', error);
          this.uiState.invalidToken = true;
        }
      },
      
      async finishLogin(response){
        if(response.error){
          this.uiState.invalidToken = true;
          return;
        }
        
        if(response.reclaimed){ 
          this.uiState.reclaimed = true;
          return;
        }
        
        if(response.cancelled){
          this.uiState.invalidToken = true;
          return;
        }
        
        await this.processLoginResponse(response);
        await this.setupCollectionData(response);
        await this.setupProducts(response);
        await this.finalizeLogin();
      },
      
      async processLoginResponse(response){
        this.collectionData.collectionHandle = response.handle;
        this.collectionData.corporate = response.corporate;
        this.collectionData.collectionImage = response.collection_image;
        this.collectionData.productSent = response.productSent;
      },
      
      async setupCollectionData(response){
        const metafields = await axios.get(`/collections/${response.handle}?view=metafields`);
        
        if(metafields.data?.metafields){
          const meta = metafields.data.metafields;
          
          if(meta.value && meta.value > 0){
            this.collectionData.collectionCapacity = meta.value;
            this.cartData.individualChoice = false;
          } else {
            this.collectionData.collectionCapacity = 1;
          }
          
          this.collectionData.videoHeaders = meta.video_headers || [];
          this.collectionData.fixed_address = meta.fixed_address?.address1 ? meta.fixed_address : null;
          this.collectionData.tickerText = meta.ticker || "";
          this.collectionData.tickerColor = meta.ticker_color || null;
          this.collectionData.redeem_without_full_capacity = meta.redeem_without_full_capacity || false;
          this.collectionData.minimum_redemption_value = meta.minimum_redemption_value != null ? meta.minimum_redemption_value : 0;
          this.collectionData.header_subtitle = meta.header_subtitle || "";
          this.collectionData.header_title = meta.header_title || "";
          this.collectionData.keepHeadersTitles = meta.goc_keep_header_title || false;
          this.collectionData.keepHeaderSubtitle = meta.goc_keep_header_subtitle || false;
          this.collectionData.goc_header_subtitle = meta.goc_header_subtitle || false;
          this.collectionData.discountCode = meta.goc_discount_code || null;
          this.collectionData.product_videos = meta.goc_product_video || [];
        }
      },
      
      async setupProducts(response){
        if(response.bundles?.length > 0){
          this.collectionData.isBundle = true;
          this.collectionData.bundles = response.bundles;
          this.collectionData.products = this.processBundleProducts(response.bundles);
        } else {
          this.collectionData.products = this.processRegularProducts(response.products);
        }
      },
      
      processBundleProducts(bundles){
        return bundles.flatMap((x, i) => {
          return x.products.map((y) => {
            y.variants = y.variants.filter(z => z.price === "0.00").map((z) => {
              if(z.inventory_policy === "continue"){
                z.inventory_quantity = 999;
              }
              return z;
            });
            y.tab = i;
            return y;
          });
        });
      },
      
      processRegularProducts(products){
        return products.map((x) => {
          x.variants = x.variants.filter(y => y.price === "0.00").map((y) => {
            if(y.inventory_policy === "continue"){
              y.inventory_quantity = 999;
            }
            return y;
          });
          
          if(this.cartData.individualChoice){
            this.addCapacityTagIfMissing(x);
          }
          
          return x;
        });
      },
      
      addCapacityTagIfMissing(product){
        let tags = product.tags ? product.tags.split(", ") : [];
        let hasCapacityTag = false;
        
        tags = tags.map(tag => {
          if (tag.startsWith("GOC_Capacity_")) {
            hasCapacityTag = true;
            return "GOC_Capacity_1";
          }
          return tag;
        });
        
        if (!hasCapacityTag) {
          tags.push("GOC_Capacity_1");
        }
        
        product.tags = tags.join(", ");
      },
      
      async finalizeLogin(){
        this.userData.loggedIn = true;
        
        await this.$nextTick();
        this.setupEventListeners();
        this.setupIntersectionObserver();
      },
      
      setupEventListeners(){
        const canvas = document.getElementById('canvas');
        if(!canvas) return;
        
        if(window.matchMedia("(pointer: coarse)").matches) {
          canvas.addEventListener('touchend', this.onTouchEnd, false);
        } else {
          canvas.addEventListener('mousemove', this.onMouseMove, false);
        }
      },
      
      setupIntersectionObserver(){
        const element = document.getElementById("tabs");
        if(!element) return;
        
        const observer = new IntersectionObserver((entries) => {
          if(entries[0].intersectionRatio < 1){
            this.uiState.isSticking = true;
          } else {
            this.uiState.isSticking = false;
          }
        }, { threshold: [0,1] });
        
        observer.observe(element);
      },
      
      // Pointer tracking methods
      onMouseMove(e){
        this.pointerPosition.x = e.clientX / window.innerWidth;
        this.pointerPosition.y = e.clientY / window.innerHeight;
      },
      
      onTouchEnd(e){
        if(e.changedTouches.length > 0){
          this.pointerPosition.x = e.changedTouches[0].clientX / window.innerWidth;
          this.pointerPosition.y = e.changedTouches[0].clientY / window.innerHeight;
        }
      },
      
      // Tab selection methods
      selectTab(value){
        if(this.collectionData.isBundle){
          const tab = this.tabs.find(x => x.value === value);
          if(tab.currentQty === 0 || tab.value === 0 || this.tabs[value - 1].currentQty === 0){
            this.uiState.selectedTab = value;
          }
        } else {
          this.uiState.selectedTab = value;
        }
        
        document.getElementById('mContainer')?.scrollTo({ top: 0, behavior: 'auto' });
      },
      
      // Checkout methods
      async goCheckout(){
        if(!this.canProceedToCheckout || this.uiState.isLoading){
          return;
        }
        
        if(this.collectionData.corporate === "Capital One" && !this.uiState.confirmed){
          this.fireSwalAlert();
          return;
        }
        
        this.uiState.isLoading = true;
        if(!this.sso){
          await this.validateToken();
        }
        else{
          await this.logout();
        }
        await this.clearCart();
      },
      
      async fireSwalAlert(){
        const result = await Swal.fire({
          title: 'Confirm Final Gift Selection',
          html: `<p>Once you click "submit", you'll be prompted to complete your gift redemption <br/> experience, and you will not be able to adjust your gift selection.</p>`,
          showCancelButton: true,
          confirmButtonText: "Submit Gift Selection",
          cancelButtonText: "Adjust Gift Selection",
          reverseButtons: true,
          customClass:{
            container:"swal-custom-container",
            popup: "swal-custom-popup-2 rounded",
            title:"swal-title",
            confirmButton: "happybox-button green border",
            cancelButton: "happybox-button white border",
          },
          buttonsStyling: false,
        });
        
        if (result.isConfirmed) {
          this.uiState.confirmed = true;
          this.goCheckout();
        }
      },
      
      async validateToken(){
        try {
          const response = await axios.post(API_ENDPOINTS.GIFT_LOGIN, {
            token: this.userData.giftToken
          });
          
          if(response.data){
            const data = response.data;
            if(data.error || data.cancelled || data.reclaimed){
              location.reload();
            }
          } else {
            location.reload();
          }
        } catch(error) {
          console.error('Token validation error:', error);
          location.reload();
        }
      },
      
      async clearCart(){
        try {
          await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            }
          });
          
          if(this.cartData.fixed_address){
            await this.specialCheckout();
          } else {
            await this.addToCart();
          }
        } catch(error) {
          console.error('Cart clear error:', error);
        }
      },
      
      async specialCheckout(){
        try {
          const response = await axios.post(API_ENDPOINTS.SPECIAL_CHECKOUT, {
            address: this.cartData.fixed_address,
            'items': this.dataToAdd
          }, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': this.userData.giftToken,
            },
            timeout: ANIMATION_DURATION
          });
          
          this.setCheckoutRedirect();
          location.href = response.data.draftOrder.invoiceUrl;
        } catch(error) {
          console.error('Special checkout error:', error);
        }
      },
      
      async addToCart(){
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items: this.dataToAdd })
          });
          if(this.collectionData.discountCode){
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ discount: this.collectionData.discountCode })
            });
          }
          
          this.setCheckoutRedirect();
          window.location.href = '/checkout';
        } catch(error) {
          console.error('Add to cart error:', error);
        }
      },
      
      setCheckoutRedirect(){
        localStorage.setItem('_gs-redirect', true);
        localStorage.setItem('gift', true);
        localStorage.removeItem('giftToken');
      },
      
      // Utility methods
      nextStep(){
        this.selectTab(this.uiState.selectedTab + 1);
      },
      
      isNoHover(product){
        return product.tags.includes("no_hover");
      },
      
      // SSO methods
      async checkUser() {
        try {
          const returnUrl = window.location.href;
          const response = await axios.get(`${API_ENDPOINTS.SSO_ME}?url=${encodeURIComponent(returnUrl)}`, { 
            withCredentials: true 
          });
          
          const res = response?.data;
          if(res.claimed){
            this.uiState.reclaimed = true;
            this.sso = false;
            return;
          }
          if(res.valid){
            this.userData.giftToken = res.responseData.token;
            this.finishLogin(res.responseData);
          }
          else{
            this.userData.isLoggedIn = true;
            this.userData.loggedUser = res.user;
            this.loadingSSO = false;
          }
        } catch (error) {
          console.error('Error fetching user info:', error);
          this.loadingSSO = false;
        }
      },
      
      ssologin(provider) {
        this.loadingSSO = true;
        const returnUrl = window.location.href;
        window.location.href = `${API_ENDPOINTS.SSO_LOGIN}?provider=${provider}&returnUrl=${encodeURIComponent(returnUrl)}`;
      },
      
      async logout() {
        try {
          await axios.get(API_ENDPOINTS.SSO_LOGOUT, { withCredentials: true });
        } catch (error) {
          console.error('Logout error:', error);
        }
      },
      async getSSOInfo(){
        try {
          const metafields = await axios.get(`${window.location.pathname}?view=metafields`);
          if(metafields.data?.metafields){
            const meta = metafields.data.metafields;
            this.loginData.loginBackgroundColor = meta.sso_background_color || null;
            this.loginData.loginBackgroundImage = meta.sso_background_image || null;
            this.loginData.loginMobileBackgroundImage = meta.sso_mobile_background_image || null;
            this.loginData.loginLogo = meta.sso_logo || null;
            this.loginData.loginTitle = meta.sso_title || null;
            this.loginData.loginTitleColor = meta.sso_title_color || null;
            this.loginData.loginSubtitle = meta.sso_subtitle || null;
            this.loginData.loginSubtitleColor = meta.sso_subtitle_color || null;
            this.loginData.hideMSButton = meta.hide_ms_button || false;
            this.loginData.loginButton = meta.sso_button || null;
            this.loginData.loginButtonText = meta.sso_button_text || null;
            this.loginData.loginButtonLink = meta.sso_button_link || null;
            this.loginData.loginPoweredByColor = meta.sso_powered_by_color || null;
            this.loginData.loading = false;
          }
        } catch (error) {
          console.error('Get SSO info error:', error);
        }
      },
      onResize() {
        this.isMobile = window.innerWidth <= 768
      }
    },
    mounted(){
      window.addEventListener('resize', this.onResize)
      const canvas = document.getElementById('IndividualChoice');
      const sso = document.getElementById('RedeemWithSSO');
      
      if(canvas){
        this.cartData.individualChoice = true;
      }
      
      if(sso){
        this.loginData.loading = true;
        this.sso = true;
        this.getSSOInfo();
        this.checkUser();
      } else {
        this.login();
      }
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.onResize)
    },
}
</script>

<style>
    #attentive_overlay{
      display: none;
    }

    .gift-choice-page p,.gift-choice-page span{
      color: #0F0C38;
      margin: 0;
    }

    .mothers-day-ticker{
      display: none;
    }
    </style>



    <style scoped>
    .wiggle{
        width: 100%;
        overflow: hidden;
        position: relative;
    }

    .wiggle img{
        width: 120%;
        height: 100%;
        position: relative;
        left: -10%;
    }

    .gift-choice-page{
      width: 100%;
      display: flex;
      overflow: hidden;
      height: 100%;
    }

    .gift-choice-page .header.custom img{
      padding: unset;
      width: 100%;
    }

    .gift-choice-page .header{
      background-color: #f2f6ff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .gift-choice-page .header img{
      width: 23%;
      padding: 2% 0%;
    }

  .wiggle.white{
		background: linear-gradient(0deg, white 40%, #eee6ff 60%);
	}

  .happybox-button.orange{
    padding: 1% 10%;
    font-size: 1.5vw;
    border: 1px solid #d9bd47;
  }

  .gift-choice-page .main-container{
    text-align: center;
    width: 100%;
    min-width: 90%;
    height: 100%;
    overflow: auto;
    scroll-behavior: smooth;
    background-color: #f8f9fd;
    display: flex;
    flex-direction: column;
  }

  .gift-choice-page .main-container .main-title{
    margin-top: 1%;
    font-size: 4vw;
    font-weight: 500;
    font-family: ff-more-web-pro-condensed,sans-serif;
  }

  .gift-choice-page .main-container .corporate .main-title{
    font-size: 5vw;
    font-weight: 300;
    font-family: ff-more-web-pro-condensed,sans-serif;
    line-height: 1.2;
  }

  .gift-choice-page .main-container .main-subtitle{
    font-size: 1.3vw;
    margin-bottom: 1em;
    line-height: 1.2;
  }

  .next-step{
    font-size: 1.8vw;
    margin: 2% 0%;
  }

  .next-step span,.next-step strong{
    font-style: italic;
    font-family: moret,sans-serif;
  }

  .main-legend{
    text-align: left;
    font-size: 1.6vw;
    padding-bottom: 5%;
  }

  .products-listing{
    width: 100%;
    padding: 2% 10% 2% 5%;
    min-height: 40vh;
    background-color: #f8f9fd;
    box-shadow: 0px -1px 0px 1px #0000001f;
    position: relative;
  }

  .products-listing .product-video-container{
    width: 23%;
    height: auto;
    object-fit: cover;
    border-radius: 8px;
    position: relative;
    flex-shrink: 0;
  }

  .products-listing .product-video-container video{
    width: 100%;
  }

  .product-container {
    width: 23%;
    background-color: white;
    box-shadow: 0 0 2px #0000004d;
    border-radius: 8px;
    padding: 1%;
    position: relative;
  }

  .product-container.big{
    width: 40%;
  }

  .product-container.big .product-title{
    font-size: 2vw;
  }

  .product-container .loading {
    width: 100%;
    height: auto;
    cursor: pointer;
    position: relative;
  }
  .product-container .loading .main-image{
    z-index: 2;
    background-color: #f6f6f6;
    height: 100%;
    width: 100%;
    position: relative;
    aspect-ratio: 1;
    display: block;
    object-fit: cover;
  }

  .product-container .loading:before {
    content: "";
    position: absolute;
    z-index: 1;
    top: 0%;
    left: 0%;
    width: 100%;
    padding-bottom: 100%;
    animation: skeleton-loading 1s linear infinite alternate;
  }

  .product-container .hover-image {
    background-color: #f6f6f6;
    width: 100%;
    height: 100%;
    object-fit: contain;
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 2;
    -webkit-transition: all .35s ease-in-out;
    transition: all .35s ease-in-out;
    opacity: 0;
  }

  .product-image-container:hover .hover-image {
    opacity: 1;
  }

  .product-container .product-title{
    font-size: 1vw;
    margin: 5% 0%;
    font-weight: bold;
    line-height: 1.2;
    text-align: center
  }

  .product-image-container{
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
  }

  .product-container.selected{
    border: 2px solid var(--color-link);
  }

  .hover-container {
    display: flex;
    position: absolute;
    width: 100%;
    bottom: -30%;
    margin: unset;
    -webkit-transition: all .35s ease-in-out;
    transition: all .35s ease-in-out;
    background-color: rgba(225,231,253,0.8);
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
    z-index: 2;
  }

  .hover-container img{
    width: 10%;
  }

  .hover-container p{
    color: #5A6BA3;
    font-size: 1vw;
    padding: 2% 0%;
    font-weight: bold;
    letter-spacing: 0.2px;
  }

  .product-image-container:hover .hover-container{
    bottom: 0%;
  }

  .product-container .white{
    border: 1px solid #CFCED8 !important;
  }

  .product-container .happybox-button.green{
    padding: 2%;
    width: 80%;
    font-size: 1.15vw;
    margin-bottom: 5%;
  }

  .continue-container button{
    border: 1px solid #CFCED8;
    padding: 1% 10%;
  }

  .happybox-button.white,.happybox-button.purple,.happybox-button.yellow,.happybox-button.green{
    font-size: 1vw;
    padding: 1% 15%;
  }

  .happybox-button.purple:hover{
    background-color: #e6d7fa;
  }

  .slick-slider{
    width: 100%;
  }

  .slick-track {
  display: flex!important;
}

.slick-slide {
  height: inherit!important;
  display: flex!important;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.slick-slide div{
  width: 100%;
}

.slick-slider {
  margin-bottom: 15px;
}

.slick-arrow:before {
  content: ""!important;
}

  .loading-container{
    width: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .loading-container p{
    font-size: 1.15vw;
    color: #0f0c38;
    font-family: "Karla";
    margin-bottom: 2%;
    text-align: center;
  }

  .spinner-container{
    width: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 70vh;
  }

  .spinner-container.top{
    align-items: flex-start;
    padding-top: 5%;
  }

  .spinner {
    border: 4px solid rgba(0, 0, 0, 0.3);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border-left-color: #09f;
    animation: spin 1s ease infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
  .reclaimed-container{
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  .reclaimed-container .title{
    font-size: 6vw;
    font-family: moret;
    font-weight: bold;
    display: flex;
    gap: 30px;
    width: 100%;
    justify-content: center;
  }

  .reclaimed-container .title img{
    width: 3%;
  }

  .reclaimed-container .subtitle{
    font-size: 3vw;
    font-family: 'moret';
    font-weight: 300;
    width: 35%;
    text-align: center;
    line-height: 1.2;
  }

  .gifting-header{
    display: flex;
    align-items: center;
    padding: 2%;
    position: relative;
  }

  .tabs{
    width: 100%;
    display: flex;
    padding: 0% 10%;
    justify-content: center;
    position: sticky;
    top: -1px;
    z-index: 4;
  }

  .tabs .tab{
    width: 30%;
    padding: 2%;
    z-index: 1;
  }

  .tabs .tab.disabled{
    opacity: 0.8;
  }

  .tabs .tab.disabled.selected{
    opacity: 1;
  }

  .tabs .selected{
    background-color: #f8f9fd;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    box-shadow: 0px -1px 0px 1px #0000001f;
  }

  .tabs .tab .happybox-button{
    width: 100%;
    position: relative;
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tabs .selected .happybox-button{
    font-weight: 700;
  }

  .tabs .tab .arrow.down{
    display: none;
  }

  .tabs .tab .subtitle{
    font-size: 0.8vw;
    position: absolute;
    top: 25.5%;
    right: 5%;
  }

  .tabs .tab.selected .subtitle{
    display: none;
  }

  .tabs .tab.selected .arrow.down{
    display: inline-block;
    right: 10%;
    top: 40%;
    position: absolute;
  }

  .products-inner-container-wrapper{
    display: flex;
    padding: 5% 0;
    gap: 2vw;
  }

  .products-inner-container.has-videos{
    justify-content: flex-start;
  }

  .products-inner-container{
    width: 100%;
    background-color: white;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 30px 2%;
    background-color: #f8f9fd;
  }

  .selected .circle.remove{
    display: flex;
  }

  .circle.remove{
    display: none;
    align-items: center;
    justify-content: center;
    position: absolute;
    font-size: 2vw;
    width: 1.5vw;
    height: 1.5vw;
    border-radius: 50%;
    background-color: white;
    color: #0f0c38;
    top: -0.75vw;
    right: -0.75vw;
    padding: unset !important;
    z-index: 3;
    line-height: 1;
  }

  .circle.remove span{
    margin-bottom: 10%;
  }

  .arrow {
    border: solid black;
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 2px;
    height: 0px;
    transition: all 0.5s;
    cursor: pointer;
}

.arrow.up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
}

.arrow.down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}

.main-badge{
  background-color: white;
  position: absolute;
  top: 2%;
  left: 2%;
  border: 1px solid #F3EEFA;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 1% 3%;
  font-size: 1.1vw;
  font-weight: bold;
  color: #5981d9;
}

.capacity-overlay{
  color: #5a3089;
  font-size: 1.3vw;
  font-weight: bold;
}

.bundle-instructions,.tier-subcopy{
  font-size: 1.3vw;
}

.step-warning{
  color: #dc2626;
  font-size: 1.3vw;
  font-weight: bold;
}

.disabled{
  opacity: 0.6;
}

.header-container{
  width: 100%;
  display: flex;
}

.custom-header{
  width: 100%;
}

.custom-header.no-tabs{
  margin: unset;
}

@media screen and (min-width: 768px){
  .header-container{
    margin-bottom: -6%;
  }

  .tabs.sticky{
    padding-top: 1px;
    background-color: white;
  }

  .tabs.sticky.hasTicker{
    padding-top: 51px;
  }
  
  .tabs.sticky .selected{
    background-color: unset;
    box-shadow: unset;
  }

  .tabs.sticky .selected .happybox-button{
    background-color: #E0E5F3;
  }

  .product-image-container .info{
    width: 15%;
    position: absolute;
    right: 2%;
    top: 2%;
    z-index: 3;
    cursor: pointer;
    max-width: 30px;
  }
}

.ticker{
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffd9a1;
  font-weight: bold;
  line-height: 1.2;
  z-index: 3;
}

.purple-copy{
  color: #1C1856;
  font-size: 1.5vw;
}

.login-page {
        padding: 5%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #ebeeff;
        min-height: 100vh;
        justify-content: center;
    }

.login-container {
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: white;
  min-width: 350px;
  border: 1px solid #0f0c38;
}

.login-spinner{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-header {
  text-align: center;
}

.login-header h2{
  font-family: Founders Grotesk, sans-serif;
  font-size: 3vw;
  color: #0f0c38;
}

.logo {
  max-width: 150px;
  margin-bottom: 10px;
}

.input-group {
  margin-bottom: 15px;
}

.input-group label {
  display: block;
  margin-bottom: 5px;
}

.input-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}

.login-button {
  width: 100%;
  margin-top: 1rem;
  max-width: unset;
}

.login-button:disabled{
  background-color: rgb(242, 244, 246);
  opacity: 0.7;
}

.forgot-password {
  font-size: 1vw;
  text-align: right;
  width: 100%;
  text-decoration: none;
  cursor: pointer;
  color: #0f0c38;
}

.alternative-login {
  text-align: center;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.alternative-login p {
  margin-bottom: 10px;
}

.signup-prompt {
  text-align: center;
  color: #0f0c38;
  font-size: 1vw;
}

.signup-prompt a {
  color: #7f38d0;
  text-decoration: underline;
  cursor: pointer;
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 20px 0;
}

.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #ccc;
  margin: 5px;
}

.separator span {
  padding: 0 10px;
  font-size: 14px;
  font-weight: bold;
  color: rgba(15,12,56,0.7);
}

.google-sign-in-button {
    cursor: pointer;
    transition: background-color .3s, box-shadow .3s;
        
    padding: 2% 42px;
    border-radius: 16px;
    box-shadow: 0 -1px 0 rgba(0, 0, 0, .04), 0 1px 1px rgba(0, 0, 0, .25);
    
    color: #757575;
    font-size: 14px;
    font-weight: 500;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif;
    
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMyAxMiAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4=);
    background-color: white;
    background-repeat: no-repeat;
    background-position: 12px 45%;
    border: 1px solid #0F0C38;
}
.google-sign-in-button.microsoft{
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDIxIDIxIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dGl0bGU+TVMtU3ltYm9sTG9ja3VwPC90aXRsZT4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCB4PSIxIiB5PSIxIiB3aWR0aD0iOSIgaGVpZ2h0PSI5IiBmaWxsPSIjZjI1MDIyIi8+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgeD0iMSIgeT0iMTEiIHdpZHRoPSI5IiBoZWlnaHQ9IjkiIGZpbGw9IiMwMGE0ZWYiLz4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCB4PSIxMSIgeT0iMSIgd2lkdGg9IjkiIGhlaWdodD0iOSIgZmlsbD0iIzdmYmEwMCIvPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0IHg9IjExIiB5PSIxMSIgd2lkdGg9IjkiIGhlaWdodD0iOSIgZmlsbD0iI2ZmYjkwMCIvPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9zdmc+);
  border-radius: 4px;
  color: white;
  background-color: black;
}
.google-sign-in-button.microsoft:hover{
  color: black;
}
.google-sign-in-button:hover {
  background-color: rgb(240, 240, 240);
}

.google-sign-in-button:active {
    background-color: #eeeeee;
    outline: none;
        box-shadow: 
        0 -1px 0 rgba(0, 0, 0, .04),
        0 2px 4px rgba(0, 0, 0, .25),
        0 0 0 3px #c8dafc;
}

.md-field.md-invalid .md-error{
  color: red;
}

.logged-container{
  font-size: 1vw;
  color: red;
}

.global-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;
}

.floating-text{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);
  width: 100%;
}

  @media screen and (max-width: 767px){

    .login-header h2{
      font-size: 6vw;
    }

    .wiggle img{
      width: 100%;
      left: unset;
    }
    
    .gift-choice-page .header .title{
      font-size: 8vw;
    }

    .floating-text{
      transform: translate(-50%, -50%);
    }

    .gift-choice-page .main-container .main-title,.gift-choice-page .main-container .corporate .main-title{
      font-size: 8vw;
    }

    .gift-choice-page .main-container .main-subtitle{
      font-size: 3.5vw;
      padding: 0% 10%;
      font-weight: 500;
    }

    .product-container {
      width: 47%;
      margin-bottom: 5%;
    }

    .happybox-button.orange{
      font-size: 3.5vw;
      width: 100%;
      margin-top: 5%;
    }

    .happybox-button.white, .happybox-button.purple,.happybox-button.yellow,.happybox-button.green{
      font-size: 3.5vw;
    }

    .next-step{
      font-size: 5vw;
      margin: 5% 0%;
    }

    .continue-container{
        width: 100%;
        background-color: white;
        display: flex;
    }

    .continue-container.sticky{
      position: fixed;
      bottom: 0%;
      left: 0;
      padding: 5%;
      border-top: 1px solid black;
      align-items: center;
      justify-content: center;
    }

    .continue-container button{
      font-size: 3.5vw;
      width: 100%;
      padding: 2% !important;
      border: unset !important;
    }

    .gifting-header{
      justify-content: center;
    }

    .header-step{
      width: 50%;
    }

    .header-step .title{
      font-size: 3vw;
    }

    .header-step .circle{
      width: 4vw;
      height: 4vw;
    }

    .header-line{
      bottom: 33%;
    }

    .hover-container{
      display: none;
    }

    .product-container .happybox-button.green{
      font-size: 3.5vw;
    }

    .product-container .product-title{
      font-size: 3vw;
    }

    .products-listing{
      padding: 5%;
      gap: unset;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      margin-top: 0.5%
    }

    .gift-choice-page .header img{
      width: 70%;
    }

    .product-image-container .info{
      width: 10%;
      position: absolute;
      right: 2%;
      top: 2%;
      z-index: 3;
      cursor: pointer;
    }

    .loading-container p{
      font-size: 3vw;
      text-align: center;
    }

    .tabs{
      padding: 5% 2%;
      overflow-x: scroll;
      gap: 10px;
      justify-content: flex-start;
      background-color: white;
      align-items: center;
    }

    .tabs .tab{
      width: auto;
      flex-shrink: 0;
      padding: 1% 2%;
      border: 1px solid #0F0C38;
      border-radius: 100px;
    }

    .tabs .selected{
      background-color: unset;
      box-shadow: unset;
      border: 1px solid #7d1deb;
    }

    .tabs .tab .happybox-button{
      background-color: unset;
      padding: unset;
      border: unset;
      border-radius: unset;
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 3vw;
    }

    .tabs .tab .subtitle{
      display: none;
    }

    .tabs .tab.selected .arrow.down{
      position: static;
      border: solid #7d1deb;
      border-width: 0 2px 2px 0;
    }

    .tabs .selected .happybox-button span{
      color: #7d1deb;
    }

    .selected .circle.remove{
      display: none;
    }
    .capacity-overlay{
      font-size: 3.5vw;
      text-align: center;
    }

    .custom-header{
      margin: unset
    }

    .ticker{
      height: 60px;
    }

    .tabs.sticky.hasTicker{
      padding-top: 61px;
    }

    .product-container.big{
      width: 100%;
    }

    .product-container.big .product-title{
      font-size: 3.5vw;
    }

    .purple-copy,.bundle-instructions,.tier-subcopy,.step-warning{
      font-size: 3.5vw;
    }

    .products-listing .product-video-container{
      width: 100%;
      margin-bottom: 5%;
    }

    .products-inner-container-wrapper{
      flex-direction: column;
    }
  }
  
</style>